module.exports = __webpack_public_path__ + "static/media/plan.7d61a82e.svg";